// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"361":"116b2ed5","951":"b519afbe"}[chunkId] + ".chunk.css";
};